// extracted by mini-css-extract-plugin
export var auto = "_3w-1";
export var spinner = "_3w-0";